import Link from 'next/link'
import { ReactNode } from 'react'

type TermsOfUseProps = {
  checkboxComponent: ReactNode
  id: string
}

const TermsOfUse = ({ id, checkboxComponent }: TermsOfUseProps) => {
  return (
    <div className="flex items-center gap-2">
      <div className="relative flex items-center rounded-full">
        {checkboxComponent}
      </div>

      <div className="required-field flex w-full items-center gap-1">
        <label
          className="cursor-pointer select-none text-xs"
          htmlFor={id}
          aria-label="Declaro que li e aceito os termos de uso."
        >
          Declaro que li e aceito os{' '}
          <Link
            href="/documents/terms-of-use.pdf"
            target="_blank"
            className="font-bold text-brand-green-primary-5"
          >
            Termos de Uso{' '}
          </Link>
          e{' '}
          <Link
            href="/documents/privacy-policy.pdf"
            target="_blank"
            className="font-bold text-brand-green-primary-5"
          >
            Política de Privacidade
          </Link>
        </label>
      </div>
    </div>
  )
}

export default TermsOfUse
